var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-body"},[_vm._l((_vm.companyConfigs),function(config){return _c('AuditConfig',{key:config.id,attrs:{"config":config},on:{"update":_vm.onConfigChange}})}),_c('Loading',{attrs:{"is-loading":_vm.isLoading}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }